export enum ModalType {
  Default = 'default',
  Minimal = 'minimal',
  Accordion = 'accordion'
}

export interface ModalTypeProperties {
  type: string;
  classname: boolean;
  header: boolean;
  focus: boolean;
  footer: boolean;
}
